import { useEffect } from "react";
import { useLocation, useRoute, useSearch } from "wouter";
import { useAuth } from "../lib/auth";
import { profileKey } from "../lib/profileSession";
import { ContractWorkspaceLayout } from "../components/ContractWorkspaceLayout";
import { ContractActivity } from "./contracts/ContractActivity";

/** A quotation can have history before any contract exists. Its source card
 * owns consent and discussion; this workspace mounts only the shared reader. */
export default function QuotationActivity() {
  const { user, loading } = useAuth();
  const [, navigate] = useLocation();
  const [, params] = useRoute("/quotations/:id/activity");
  const search = useSearch();
  const kind = new URLSearchParams(search).get("kind") === "rfq_items" ? "rfq_items" as const : "quotation" as const;
  useEffect(() => { if (!loading && !user) navigate("/login"); }, [loading, user, navigate]);
  if (!user || !params?.id) return null;
  return <ContractWorkspaceLayout header={{ title: "Quotation", subtitle: kind === "rfq_items" ? "Items RFQ" : "", messageHref: null, messageLabel: "" }}
    tabs={[{ key: "activity", label: "Activity" }]} activeTab="activity" onTabChange={() => {}}
    onBack={() => navigate("/messages")} backLabel="Back to Messages" error={null} summary={null} fullWidth>
    <ContractActivity key={`${profileKey(user)}:${kind}:${params.id}`} target={{ kind, id: params.id }} />
  </ContractWorkspaceLayout>;
}
